export default "__VITE_ASSET__0mpihTjP__"